export default {
  back: 'Zurück',
  next: 'Weiter',
  loading: 'Survey wird geladen...',
  loadError: 'Fehler beim Laden der Survey',
  loadErrorMessage:
    'Die Survey konnte nicht geladen werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support.',
  sendError: 'Fehler beim Senden der Daten:',
  generalError: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
  analyzing: 'Eingaben werden übermittelt...',
  pleaseWait: 'Bitte warten Sie einen Moment',
  defaultThankYou: 'Vielen Dank für Ihre Teilnahme!',
  thankYouTitle: 'Vielen Dank!',
  answersSubmitted: 'Ihre Antworten wurden erfolgreich übermittelt.',
  redirectingIn: 'Sie werden in {n} Sekunde{s} weitergeleitet...',
  redirectNow: 'Jetzt weiterleiten',
  defaultThankYouHtml:
    '<h2>Vielen Dank!</h2><p>Vielen Dank für Ihre Teilnahme. Wir werden uns in Kürze bei Ihnen melden.</p>',
  emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  requiredField: 'Das ist ein Pflichtfeld',
  emailInvalidShort: 'Keine gültige E-Mail-Adresse.',
  checkInputs: 'Bitte überprüfe deine Eingaben.',
  requiredLabel: 'Pflichtfeld',
  formAriaLabel: 'Formular absenden',
  selectPlaceholder: 'Bitte wählen Sie eine Option...',
  answerPlaceholder: 'Antwort...',
  multiChoiceBetween: 'Wählen Sie zwischen {min} und {max} Optionen.',
  multiChoiceMin: 'Wählen Sie mindestens {min} Option(en).',
  multiChoiceMax: 'Wählen Sie maximal {max} Option(en).',
  multiChoiceSelected: '{count} Option(en) ausgewählt',
  fieldRequired: 'Dieses Feld ist erforderlich',
  numberInvalid: 'Bitte geben Sie eine gültige Zahl ein',
  numberMin: 'Mindestens {min}',
  numberMax: 'Maximal {max} {unit}',
  sliderRequired: 'Bitte einen Wert wählen',
  selectRequired: 'Bitte eine Option wählen',
  multiChoiceRequired: 'Bitte mindestens eine Option wählen',
  multiChoiceMinRequired: 'Mindestens {min} Option(en) erforderlich',
  multiChoiceMaxAllowed: 'Maximal {max} Option(en) erlaubt',
} as Record<string, string>
